import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { DEFAULT_PARAMS } from '../../../common/filterCompany/constant'
import { Element } from '../../../common/html/element'
import { getFormatedUnit } from '../../../common/selectCurrencyUnit/helper'
import {
  changeAllCurrency,
  changeAllUnit,
} from '../../../common/selectCurrencyUnit/slice'
import { selectCompanyInfo } from '../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, { UPDATE_LOADING_PDF } from '../../../helpers/EventEmitter'
import { getUnique } from '../../../helpers/common'
import {
  HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING,
  TYPE_ITEM_PDF,
  TYPE_ITEM_SETTING,
  WIDTH_PDF_LANSCAPE,
  WIDTH_PDF_PORTRAIT,
} from '../constant'
import { getPanelDetail, isFs, isMacroeconomics } from '../helper'
import { thunkCommon } from '../helper/thunkCommon'
import {
  selectCompanyType,
  selectCurrencyUnitFs,
  selectCurrentPortfolio,
  selectSettingFs,
} from '../preferenceSetting/detailTemplate/store/slice'
import ChaperHeader from './ChaperHeader'
import { HtmlToImage } from './HtmlToImage'
import Note from './Note'
import PdfData from './PdfData'
import TitlePanel from './TitlePanel'

const ComponentsToPdfData = ({ items, onDone }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const companyInfo = useSelector(selectCompanyInfo)
  const portfolioId = useSelector(selectCurrentPortfolio)
  const currencyUnitFs = useSelector(selectCurrencyUnitFs)
  const settingFs = useSelector(selectSettingFs)
  const companyType = useSelector(selectCompanyType)

  const countProcessDone = useRef(0)
  const pdfData = useRef(new PdfData())
  const detailItems = useRef([])
  const isProcessingFs = useRef(false)
  const isFirstContentFs = useRef(true)

  const [loading, setLoading] = useState(true)
  const [processingItem, setProcessingItem] = useState(null)

  const portfolioParams = {
    ...DEFAULT_PARAMS,
    portfolioIds: portfolioId ? [portfolioId] : [],
  }

  useEffect(() => {
    const newDetailItems = []
    items.forEach((item, index) => {
      const isPanel = item.type === TYPE_ITEM_SETTING.PANEL

      const isLandscape =
        isFs(item.screen) ||
        isMacroeconomics(item?.panel) ||
        (item.type === TYPE_ITEM_SETTING.CHAPTER_HEADER &&
          isFs(items[index + 1]?.screen))
      if (isPanel) {
        newDetailItems.push({
          id: 'title' + item.id,
          isLandscape,
          title: item.title,
          subTitle: item?.subTitle,
          type: TYPE_ITEM_PDF.TITLE_PANEL,
        })
      }
      const extendParam = { currencyUnitFs, settingFs }
      const detailItem = getPanelDetail({
        ...item,
        ...extendParam,
        companyType,
      })
      if (!detailItem.components) {
        newDetailItems.push({
          ...item,
          ...detailItem,
          title: !isPanel ? item.title : undefined,
          subTitle: !isPanel ? item?.subTitle : undefined,
          isLandscape,
          type: isPanel
            ? TYPE_ITEM_PDF.CONTENT_PANEL
            : TYPE_ITEM_PDF.CHAPTER_HEADER,
        })
      } else {
        const components = detailItem.components
        components.forEach((renderComponent, index) => {
          let title = undefined
          if (isLandscape) {
            // add title TOC currency unit FS
            const numberOfTabFs = components.length / currencyUnitFs.length
            if (!(index % numberOfTabFs)) {
              const indexCurrencyUnit = index / numberOfTabFs
              const currencyUnit = currencyUnitFs[indexCurrencyUnit]
              title =
                I18n.t('dynamicReport.IN') +
                ' ' +
                getFormatedUnit(
                  locale,
                  currencyUnit.currency,
                  currencyUnit.unit,
                )
            }
          }
          newDetailItems.push({
            ...item,
            ...detailItem,
            renderComponent,
            title,
            isLandscape,
            type: isPanel
              ? TYPE_ITEM_PDF.CONTENT_PANEL
              : TYPE_ITEM_PDF.CHAPTER_HEADER,
          })
        })
      }
      if (item.setting?.isHasNote && (item.setting?.note || '').trim()) {
        newDetailItems.push({
          id: 'note' + item.id,
          isLandscape,
          note: item.setting.note.trim(),
          type: TYPE_ITEM_PDF.NOTE,
        })
      }
    })

    const thunks = newDetailItems.reduce((result, detail) => {
      if (detail.thunk) {
        return [...result, ...detail.thunk]
      }
      return result
    }, [])

    const dispatchThunk = async () => {
      let commonData = []

      const filterThunkCommon = thunkCommon.filter((item) =>
        newDetailItems
          .map((item) => item.dependThunks)
          .flat()
          .includes(item.key),
      )
      if (filterThunkCommon.length) {
        commonData = await Promise.allSettled(
          filterThunkCommon.map(({ thunk }) =>
            dispatch(thunk({ companyInfo, portfolioParams })),
          ),
        )
      }

      if (thunks.length) {
        await Promise.allSettled(
          thunks
            .filter((thunk) => !!thunk)
            .map((thunk) =>
              dispatch(
                thunk({ companyInfo, commonData, portfolioParams, settingFs }),
              ),
            ),
        )
      }

      setLoading(false)

      detailItems.current = newDetailItems

      const firstItem = newDetailItems[0]
      if (firstItem.isLandscape) {
        isProcessingFs.current = true
        pdfData.current.currentPageData.isLandscape = true
        pdfData.current.availableHeightPage =
          HEIGHT_PDF_LANSCAPE_WITHOUT_PADDING
      }
      setProcessingItem(firstItem)

      dispatch(changeAllCurrency(currencyUnitFs[0]?.currency))
      dispatch(changeAllUnit(currencyUnitFs[0]?.unit))
    }

    dispatchThunk()

    const returnFuncs = newDetailItems.reduce((result, detail) => {
      if (detail.return) {
        return [...result, detail.return]
      }
      return result
    }, [])

    if (returnFuncs.length) {
      return () => returnFuncs.forEach((func) => func(dispatch))
    }
  }, [items])

  const onDoneProcess = (item) => {
    pdfData.current.addData({
      id: item.id,
      title: item.title,
      subTitle: item?.subTitle,
      type: item.type,
      img: item.img,
      isLandscape: processingItem.isLandscape,
    })

    countProcessDone.current += 1

    EventEmitter.dispatch(
      UPDATE_LOADING_PDF,
      countProcessDone.current / detailItems.current.length,
    )

    if (countProcessDone.current === detailItems.current.length) {
      onDone(pdfData.current.getData())
    } else {
      const itemProcessing = detailItems.current[countProcessDone.current]
      if (!itemProcessing.isLandscape && isProcessingFs.current) {
        pdfData.current.addNewPage()
        isProcessingFs.current = false
      } else if (itemProcessing.isLandscape && !isProcessingFs.current) {
        pdfData.current.addNewPage(true)
        isProcessingFs.current = true
      } else if (
        itemProcessing.isLandscape &&
        itemProcessing.type === TYPE_ITEM_PDF.CONTENT_PANEL
      ) {
        if (isFirstContentFs.current) {
          isFirstContentFs.current = false
        } else {
          pdfData.current.addNewPage(true)
        }
      }
      setProcessingItem(itemProcessing)
    }
  }

  if (loading) {
    return
  }

  return (
    <>
      {processingItem && (
        <HtmlToImage
          key={getUnique()}
          id={processingItem.id}
          onDoneProcess={onDoneProcess}
          isWaitForMount={processingItem.isWaitForMount}
          item={processingItem}
          availableHeightPage={pdfData.current.getAvailableHeightPage()}
          currentTitlePanel={pdfData.current.getCurrentTitlePanel()}
          isTable={processingItem.isTable}
          isFixSvg={processingItem.isFixSvg}
          isLandscape={processingItem.isLandscape}
        >
          <Element
            style={{
              width:
                processingItem.width ||
                (processingItem.isLandscape
                  ? WIDTH_PDF_LANSCAPE
                  : WIDTH_PDF_PORTRAIT),
              fontFamily: 'sans-serif',
              color: '#3A414B',
            }}
          >
            {processingItem.type === TYPE_ITEM_PDF.CONTENT_PANEL ? (
              <>
                {processingItem.renderComponent({
                  companyInfo,
                  setting: processingItem.setting,
                })}
              </>
            ) : processingItem.type === TYPE_ITEM_PDF.CHAPTER_HEADER ? (
              <ChaperHeader title={processingItem.title} />
            ) : processingItem.type === TYPE_ITEM_PDF.TITLE_PANEL ? (
              <TitlePanel
                title={processingItem.title}
                subTitle={processingItem?.subTitle}
              />
            ) : (
              <Note note={processingItem.note} />
            )}
          </Element>
        </HtmlToImage>
      )}
    </>
  )
}

export default ComponentsToPdfData
